import React from "react";
import { MapPin, Truck, CheckCircle2 } from "lucide-react";
import { TOPBAR_ITEMS, BRAND, HEADER } from "@/content";

const ICONS = { MapPin, Truck, CheckCircle2 };

export default function TopBar() {
  return (
    <>
      {/* Franja superior */}
      <div
        style={{ background: "var(--vino)" }}
        className="w-full text-white"
        data-testid="topbar"
      >
        <div className="container-page">
          <div className="flex items-center justify-center gap-x-3 gap-y-1 flex-wrap py-2.5 md:h-10 md:py-0 text-[12px] md:text-[13px] leading-tight">
            {TOPBAR_ITEMS.map((item, i) => {
              const Icon = ICONS[item.icon] || CheckCircle2;
              return (
                <React.Fragment key={item.text}>
                  {i > 0 && (
                    <span className="hidden sm:inline text-white/40" aria-hidden="true">
                      ·
                    </span>
                  )}
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
                    <Icon size={14} strokeWidth={2} aria-hidden="true" />
                    {item.text}
                  </span>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>

      {/* Header con logo Nutradey (sin menú, sin enlaces salientes) */}
      <header
        className="w-full"
        style={{ background: "var(--blanco)", borderBottom: "1px solid rgba(107,31,58,0.08)" }}
        data-testid="header"
      >
        <div className="container-page">
          <div className="flex items-center justify-between py-3">
            <img
              src={BRAND.logoNutradey}
              alt="Nutradey"
              className="h-11 md:h-14 w-auto"
              data-testid="logo-nutradey"
            />
            <div className="flex items-center gap-2 md:gap-3">
              <span
                className="hidden sm:block text-[11px] md:text-[12px] text-right leading-tight"
                style={{ color: "var(--gris)" }}
              >
                {HEADER.claim}
              </span>
              <img
                src={BRAND.logoFuxion}
                alt="FuXion"
                className="h-5 md:h-7 w-auto"
                data-testid="logo-fuxion"
              />
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
